import Vue from 'vue'

// 防止重复提交指令
const preventReClick = Vue.directive('preventReClick', {
    inserted(el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 1000)
            }
        })
    }
})

const debounce = (fn, wait = 2000) => {
    let timer;
    return function() {
        let context = this;
        let args = arguments;
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, wait);
    };
};

// input输入整数或者保留小数点后两位
const decimal = Vue.directive('decimal', {
    bind(el) {
        let flag = true
        el.addEventListener('compositionstart', function() {
            flag = false;
        });
        el.addEventListener('compositionend', function() {
            flag = true;
        });
        if (flag) {
            el.onkeypress = (e) => {
                let value = e.target.value;
                // 通过正则过滤小数点后两位
                e.target.value = (e.target.value.match(/^(\d{1,3})*(.?\d{0,1})/g)[0]) || null;
            }
        }
    }
})
export { preventReClick, debounce, decimal }